const INITIAL_VALUES = {
  familyNum: '',
  familyName: '',
  chains: [],
};

export default INITIAL_VALUES;
